function ListItemText(_: any): any {
  return {
    MuiListItemText: {
      styleOverrides: {
        root: {
          '&.MuiListItemText-inset': {
            paddingLeft: 24
          }
        }
      }
    }
  };
}

export { ListItemText };
